// import '../styles/Babbitt.scss';
import '../styles/ProductsWithList.scss';

const Babbitt = () => {
    return (
        // <div className="main-babbitt">
            <div className="main">
            <h1>Babbitt</h1>
            <h3>OFTEN USED AS BEARING METAL FOR AXLES AND CRANKSHAFTS TO REDUCE FRICTION BETWEEN THE METALS</h3>
            <p>We offer a variety of tin and lead based alloys that will suit a variety of applications. When selecting Babbitt type, important factors to consider are bearing use, shaft surface speed and load factor. If a bearing is highly loaded in relation to its size, a high tin alloy is desirable; whereas lead-based alloys are suited for much slower speed work and less heavily loaded bearings.
            </p>
            <p>Below are the common Babbitts that we produce:</p>
            <div className='list-babbitt'>
            {/* <div className='list'> */}
                <ul>
                    <li>MD-4X (also called Nickel Genuine)</li>
                    <li>Heavy Pressure (also called Harris Heavy Pressure)</li>
                    <li>Saw Guide Babbitt</li>
                    <li>#4 Babbitt</li>
                    <li>Mill Anchor</li>
                    <li>Soft Choker</li>
                    <li>Choker Zinc</li>
                </ul>
            </div>
            <p>We are also able to produce custom Babbitt that meets your composition requirements</p>
        </div>
    );
};

export default Babbitt;